import * as React from "react";

import "./receipt.scss";

import {cs}          from "@Common/react/chain-services";
import {keyed}       from "@Common/react/keyed";
import {formatDate2} from "@Common/ui-components/format-date";

import {ItemReceipt}    from "./item-receipt/item-receipt";
import {ReceiptSummary} from "./receipt-summary";
import {CheckShowPricing} from "@Common/logic/check-show-pricing";

export const Receipt = ({cart, printReceipt=true}) => cs(
    () => (
        <div className="receipt receipt-8v5">
            <div className="header">
                <div className="cart-id">
                    Cart ID: {cart.cartId}
                </div>
                <div className="date">
                    Checkout Date: {formatDate2(new Date(cart.date_modified.date))}
                </div>
            </div>

            <div className="item-receipts">
                {cart.items.map((item, i) => cs(
                    keyed(item.itemId),
                    () => ItemReceipt({
                        item,
                        cart,
                        index: {
                            index: i,
                            total: cart.items.length,
                        },
                        printReceipt,
                    })
                ))}
            </div>
            {cs(
                ({}, next) => CheckShowPricing({next}),
                ({}) => (
                    <div className="footer">
                        {ReceiptSummary({cart})}
                    </div>
                )
            )}
        </div>
    ),
);
